// Shared BROE deep-link helpers (same logic as Competition Admin dashboard).

function addDecimalStrings(a, b) {
    const left = String(a || '').replace(/\D/g, '') || '0';
    const right = String(b || '').replace(/\D/g, '') || '0';

    let i = left.length - 1;
    let j = right.length - 1;
    let carry = 0;
    let out = '';

    while (i >= 0 || j >= 0 || carry > 0) {
        const av = i >= 0 ? left.charCodeAt(i) - 48 : 0;
        const bv = j >= 0 ? right.charCodeAt(j) - 48 : 0;
        const sum = av + bv + carry;
        out = String(sum % 10) + out;
        carry = Math.floor(sum / 10);
        i -= 1;
        j -= 1;
    }

    return out.replace(/^0+(?=\d)/, '');
}

export function toDotNetDateTicks(dateValue) {
    const text = String(dateValue || '').trim();
    if (!text) return '';

    let utcMillis = NaN;

    // Prefer explicit date-only parsing to avoid locale drift.
    const isoDateOnly = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const gbDateOnly = text.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (isoDateOnly) {
        const year = Number(isoDateOnly[1]);
        const month = Number(isoDateOnly[2]);
        const day = Number(isoDateOnly[3]);
        utcMillis = Date.UTC(year, month - 1, day, 0, 0, 0, 0);
    } else if (gbDateOnly) {
        const day = Number(gbDateOnly[1]);
        const month = Number(gbDateOnly[2]);
        const year = Number(gbDateOnly[3]);
        utcMillis = Date.UTC(year, month - 1, day, 0, 0, 0, 0);
    } else {
        const parsed = new Date(text);
        if (!Number.isNaN(parsed.getTime())) {
            utcMillis = parsed.getTime();
        }
    }

    if (!Number.isFinite(utcMillis)) return '';

    const unixMs = Math.trunc(utcMillis);
    if (!Number.isFinite(unixMs) || unixMs < 0) return '';

    const unixTicks = `${unixMs}0000`;
    return addDecimalStrings(unixTicks, '621355968000000000');
}

export function buildBroeCrewUrl(crewId, dateTicks) {
    const safeId = Number(crewId || 0);
    const safeTicks = String(dateTicks || '').trim();
    if (!safeId || !safeTicks) return '';
    return `https://broe2.britishrowing.org/CompetitionAdmin/ViewCrew/139?id2=${encodeURIComponent(safeTicks)}&crewId=${safeId}`;
}
